import { OutOfStock } from '../interface/interface';

export const calculateOutOfStockEnum = (
  product: any,
  orderedQuantity: number,
): OutOfStock => {
  switch (true) {
    case product?.inventory_quantity <= 0 &&
      product.substitutions_not_available:
    case product?.inventory_quantity <= 0 &&
      !product.substitutions_not_available &&
      !product?.substituteProduct:
      return OutOfStock.withNoSubs;

    case orderedQuantity >= product?.inventory_quantity &&
      product.substitutions_not_available:
      return OutOfStock.orderedQuantityExceedsWithNoSubs;

    case product?.inventory_quantity <= 0 &&
      !product?.doctorAllowedSubstitution:
      return OutOfStock.withNoDoctorApprovedSub;

    case product?.inventory_quantity <= 0:
      return OutOfStock.quantityZero;

    case orderedQuantity >= product?.inventory_quantity:
      return OutOfStock.orderedQuantityExceeds;

    default:
      return OutOfStock.false;
  }
};
